const initialState = () => ({
  loading: true,
  activeTab: 'credits',
  plans: [],
  ccMembers: [],
  ccTableOptions: {
    page: 1,
    itemsPerPage: 25,
    totalItems: 0,
    sortBy: [],
    sortDesc: [],
  },
  voucherTableOptions: {
    page: 1,
    itemsPerPage: 25,
    totalItems: 0,
    sortBy: [],
    sortDesc: [],
  },
  voucherTableSearch: '',
  ccTableSearch: '',
  ccSelectedCustomer: {},
  showActionModal: false,
  actionModalView: '',
  processing: false,
  selectedCorp: null,
  selectedPlan: null,
  sortedCorporation: [],
  transactions: [],
  ccCustomers: [],
  selectedCustomer: 0,
  comfortError: {},
  selectedLoyaltyProgramName: '',
  selectedPartnerSetting: {},
  balanceAsOfDate: new Date(),
  lastCCDate: {
    start: new Date(new Date().setDate(new Date().getDate() - 60)),
    end: new Date(),
  },
  vouchers: [],
  showRightSidebar: false,
  voucherType: '',
  redeemed: null,
  transaction: {
    method: '',
    amount: '',
    reason: '',
    rewardType: '',
    corpId: 0,
    customerId: 0,
  },
  ccFilters: {
    type: [],
    reward: '',
    transaction: '',
    selectedCustomer: {},
  },
  filterTableTab: '',
});
export default initialState;
